import SearchField from "components/fields/SearchField";
import { FaAngleRight } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Settings = () => {
    return (
      <div className="relative">
        {/* Card widget */}
        <div className="header-back-gradient">
          <div className="container">
            <div className="w-full flex items-center px-5 py-6">
              <div className="md:flex justify-between w-full md:py-6">
                <p className="relative text-header text-white md:mb-0 mb-4">Contact Us</p>
                <SearchField
                  extra="sm:min-w-[480px] xl:min-w-[650px]"
                  placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
                  id="email"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="mt-6 md:mt-12 mb-12 px-2.5 md:px-3 lg:px-5">
            <div className="grid grid-cols-1 md:grid-cols-11 gap-4">
              <div className="box bg-white dark:bg-darkPrimary overflow-hidden md:col-span-7">
                <div className="flex flex-col px-2.5 md:px-5 py-5">
                  <div className="flex gap-1 flex-row items-center justify-between flex-wrap w-full py-4 border-b-[1px] border-gray-100 dark:border-lightGrey">
                    <div className="not-italic text-large">
                    Feedback Form
                    </div>
                  </div>
                  <div className="mt-3 box bg-gray-50 dark:bg-darkGrey !shadow-none overflow-hidden px-2.5 md:px-5 py-5">
                    <p className="text-medium !font-semibold">We assist with issues directly related to BBAScan's block explorer services. Please review the following guidelines before submitting your inquiry:</p>
                    <div className="p-5">
                      <p className="mb-1.5 text-medium !font-semibold">1. Pending Transactions: </p>
                      <p className="mb-5 ml-4">We do not process transactions and are therefore unable to expedite, cancel, or replace them. If you are having issues with pending transactions.</p>
                      <p className="mb-1.5 text-medium !font-semibold">2. BBAScan Block Explorer: </p>
                      <p className="mb-5 ml-4">BBAScan is an independent block explorer and cannot provide precise responses for inquiries related to other service providers.</p>
                      <p className="mb-1.5 text-medium !font-semibold">3. Community Support: </p>
                      <p className="mb-5 ml-4">We will never ask for your private keys or passwords. NEVER share these. While we strive to respond in a timely manner, high inquiry volumes may result in delays. Please avoid sending duplicate messages.</p>
                      <p className="mb-1.5 text-medium !font-semibold">4. Wallet / Exchange / Project Issues: </p>
                      <p className="mb-5 ml-4">For wallet, exchange, or project-related issues, contact the relevant service provider or project owner for assistance, as they are better equipped to help with platform-specific problems.</p>
                    </div>
                  </div>
                  <Link to="/contact/feedback" className="mt-10 btn w-full !p-4 justify-center !font-bold flex items-center">Feedback From <span><FaAngleRight /></span></Link>
                </div>
              </div>
              <div className="box bg-white dark:bg-darkPrimary overflow-hidden md:col-span-4">
                <div className="flex flex-col px-2.5 md:px-5 py-5">
                  <div className="flex gap-1 flex-row items-center justify-between flex-wrap w-full py-4 border-b-[1px] border-gray-100 dark:border-lightGrey">
                    <div className="not-italic text-large">
                    FAQs
                    </div>
                  </div>
                  <div className="py-2">
                    <p className="mb-1.5 text-medium !font-semibold">Q1. What is BBAScan?</p>
                    <p className="mb-5 ml-4">BBAScan is a block explorer and analytics platform for the BBA blockchain. It provides tools to view, search, and analyze blockchain data, including transactions, blocks, and addresses.</p>
                    <p className="mb-1.5 text-medium !font-semibold">Q2. How does BBAScan work?</p>
                    <p className="mb-5 ml-4">BBAScan indexes blockchain data and presents it in a user-friendly interface, enabling users to track transactions, view wallet balances, and monitor network activity.</p>
                    <p className="mb-1.5 text-medium !font-semibold">Q3. Does BBAScan process transactions?</p>
                    <p className="mb-5 ml-4">No, BBAScan does not process transactions. It only provides a visualization of blockchain data. Transaction issues should be resolved with your wallet or service provider.</p>
                    <p className="mb-1.5 text-medium !font-semibold">Q4. What is the average block time?</p>
                    <p className="mb-5 ml-4">The average block time is the time it takes to create a new block on the blockchain. You can view real-time and historical block times on our "Network Status" page.</p>
                    <p className="mb-1.5 text-medium !font-semibold">Q5. How do I find a specific transaction?</p>
                    <p className="mb-5 ml-4">Use the search bar on the BBAScan homepage. You can search by transaction hash, wallet address, or block number.</p>
                    <p className="mb-1.5 text-medium !font-semibold">Q6. What is a block?</p>
                    <p className="mb-5 ml-4">No, BBAScan does not process transactions. It only provides a visualization of blockchain data. Transaction issues should be resolved with your wallet or service provider.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default Settings;